import { Box, IconButton, Image, Text, useTheme } from '@chakra-ui/react';
import React from 'react';
import { IoAddCircleOutline } from 'react-icons/io5';

interface Props {
  banner?: any;
  /** Posicao do slot: 0 e o destaque no Tipo 1. */
  index: number;
  /** Rotulo do papel do slot, ex.: "Destaque", "Quadrado 1". */
  papel: string;
  /** largura / altura do slot, para o slot lembrar o formato final. */
  aspectRatio: number;
  onClick: (banner: any) => void;
  /** Slot vazio que ainda nao pode receber banner (so o proximo da fila pode). */
  desabilitado?: boolean;
}

const Banner: React.FC<Props> = ({
  banner,
  onClick,
  index,
  papel,
  aspectRatio,
  desabilitado,
}) => {
  const theme = useTheme();
  const imagem = banner?.file?.url;

  return (
    <Box>
      <Text fontSize="xs" color="gray.500" mb={1}>
        {papel}
      </Text>
      <IconButton
        w="100%"
        h="auto"
        sx={{ aspectRatio: String(aspectRatio) }}
        aria-label={`banner-${papel}`}
        isDisabled={desabilitado}
        borderStyle="dotted"
        borderRadius="6px"
        borderWidth={4}
        overflow="hidden"
        icon={
          imagem ? (
            <Image h="100%" w="100%" objectFit="cover" src={imagem} />
          ) : (
            <IoAddCircleOutline size={25} color={theme.colors.gray['300']} />
          )
        }
        onClick={() =>
          onClick(banner ? { ...banner, position: index } : { position: index })
        }
      />
    </Box>
  );
};

export default Banner;
